import { render } from "./LabeledCheckbox.vue?vue&type=template&id=327ed867"
import script from "./LabeledCheckbox.vue?vue&type=script&lang=js"
export * from "./LabeledCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__